import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { BsDatepickerModule,AccordionModule,CarouselModule, AlertModule, ModalModule } from 'ngx-bootstrap';
import { AutoCompleteModule } from 'primeng/primeng';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { AlertMessageComponent } from './common/alert/alert.component';
import { CommonService } from './frontend-services/common.service';
import { AppSharedModule } from './app-shared.module';
import { AskForReloadComponent } from './common/ask-for-reload/ask-for-reload.component';
import { AuthInterceptor } from './http-interceptors/auth-interceptor';
import { GoogleAnalyticsService } from './admin/services/google-analytics.service';

@NgModule({
  declarations: [
    AppComponent,
    AlertMessageComponent,
    AskForReloadComponent
  ],
  imports: [
    RouterModule.forRoot(AppRoutes, {useHash: true,onSameUrlNavigation: 'reload'}),
    BrowserModule,
    BrowserAnimationsModule,
    AutoCompleteModule,
    AngularDualListBoxModule,
    BsDatepickerModule.forRoot(),
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    CarouselModule.forRoot(),
    ModalModule.forRoot(),
    AppSharedModule,
    HttpClientModule
  ],
  exports:[AlertMessageComponent,AskForReloadComponent],
  providers: [
    CommonService,
    GoogleAnalyticsService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts